import { HOTELS_HUB } from '../../constants';
import { hotelSearch, hotelSearchSetFoundTotalHotels, updateHotelSearchObj } from '../slices/hotel';
import {
  hotelSearchRequest,
  setFilters,
  setFoundTotalHotels,
  setHotelTripSearchParam,
} from '../slices/tripSearch';

const onHotelsUpdated = (store, connections, handleRemoveConnection) => (res) => {
  if (!res.hasNoResults || res.searchProgress === 100) {
    if (res.tripId) {
      if (
        store.getState().hotel.hotelSearches[res.tripId] &&
        store.getState().hotel.hotelSearches[res.tripId].requestId === res.requestId
      ) {
        if (store.getState().hotel.hasUserInteractedWithHotelList) {
          store.dispatch(
            hotelSearchSetFoundTotalHotels({
              tripId: res.tripId,
              foundTotalHotels: res.hotelsCount,
              searchProgress: res.searchProgress,
            }),
          );
        } else {
          store.dispatch(
            hotelSearch({
              tripId: res.tripId,
              doIgnoreStoredResults: true,
              searchProgress: res.searchProgress,
            }),
          );
        }
        if (res.searchProgress === 100) {
          setTimeout(() => {
            store.dispatch(
              updateHotelSearchObj({
                tripId: res.tripId,
                searchProgress: undefined,
              }),
            );
          }, 2000);
        }
      }
    } else if (res.requestId === store.getState().tripSearch.requestId) {
      if (store.getState().hotel.hasUserInteractedWithHotelList) {
        if (res.hotelsCount > 0) {
          store.dispatch(setFoundTotalHotels(res.hotelsCount));
        }
        if (res.searchProgress > 0) {
          store.dispatch(
            setHotelTripSearchParam({
              searchProgress: res.searchProgress,
            }),
          );
        }
      } else {
        store.dispatch(
          hotelSearchRequest({
            doIgnoreStoredResults: true,
            searchProgress: res.searchProgress,
          }),
        );
      }
      if (res.filters) store.dispatch(setFilters({ filters: res.filters }));
      if (res.searchProgress === 100) {
        if (connections[HOTELS_HUB] && connections[HOTELS_HUB].stop) {
          connections[HOTELS_HUB].stop().then(() => {
            console.log('Results received - connection closed');
            if (handleRemoveConnection) {
              handleRemoveConnection(HOTELS_HUB);
            }
          });
        }
        setTimeout(() => {
          store.dispatch(
            setHotelTripSearchParam({
              searchProgress: undefined,
            }),
          );
        }, 2000);
      }
    }
  }
  console.log(res);
};

export default onHotelsUpdated;
